/* Haven Print Co. — homepage interactions (reveal animations + pet bundle builder) */
(function () {
if (window.__hpHomeLoaded) return;
window.__hpHomeLoaded = true;
document.documentElement.classList.add('hp-js');
if (!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) document.documentElement.classList.add('hp-anim');

/* ---------- Reveal on scroll ---------- */
function initReveal(root) {
var els = (root || document).querySelectorAll('.hp-reveal:not(.is-in)');
if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
els.forEach(function (e) { io.observe(e); });
}

/* ---------- Bundle builder ---------- */
function initBundle(el) {
if (el.__hpInit) return; el.__hpInit = true;
var percent = parseFloat(el.dataset.percent || '15');
var threshold = parseInt(el.dataset.threshold || '2', 10);
var currency = el.dataset.currency || 'USD';
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
var money = function (cents) { return fmt.format(cents / 100); };

var picks = Array.prototype.slice.call(el.querySelectorAll('[data-hp-pick]'));
var lines = el.querySelector('[data-hp-lines]');
var empty = el.querySelector('[data-hp-empty]');
var sub = el.querySelector('[data-hp-sub]');
var save = el.querySelector('[data-hp-save]');
var saveRow = el.querySelector('[data-hp-save-row]');
var total = el.querySelector('[data-hp-total]');
var bar = el.querySelector('[data-hp-progress]');
var msg = el.querySelector('[data-hp-msg]');
var unlock = el.querySelector('[data-hp-unlock]');
var cta = el.querySelectorAll('[data-hp-cta]');
var err = el.querySelector('[data-hp-error]');
var mBar = el.querySelector('[data-hp-bar]');
var mCount = el.querySelector('[data-hp-bar-count]');
var mTotal = el.querySelector('[data-hp-bar-total]');
var wasUnlocked = false;

function variantOf(p) {
var sel = p.querySelector('select');
if (sel) { var o = sel.options[sel.selectedIndex]; return { id: o.value, price: +o.dataset.price, label: o.dataset.label || '' }; }
return { id: p.dataset.variant, price: +p.dataset.price, label: '' };
}
function selected() { return picks.filter(function (p) { return p.classList.contains('is-selected'); }); }

function render() {
var s = selected();
lines.innerHTML = '';
var subtotal = 0;
s.forEach(function (p) {
var v = variantOf(p); subtotal += v.price;
var li = document.createElement('li'); li.className = 'hp-line';
var thumb = document.createElement('div'); thumb.className = 'hp-line__thumb';
if (p.dataset.img) { var im = document.createElement('img'); im.src = p.dataset.img; im.alt = ''; im.loading = 'lazy'; thumb.appendChild(im); }
var nm = document.createElement('div'); nm.className = 'hp-line__name'; nm.textContent = p.dataset.title;
var small = document.createElement('small');
small.textContent = p.dataset.personalize === 'true' ? 'You’ll personalize this next' : (v.label || 'Ready to add');
nm.appendChild(small);
var pr = document.createElement('div'); pr.className = 'hp-line__price'; pr.textContent = money(v.price);
var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'hp-line__remove';
rm.setAttribute('aria-label', 'Remove ' + p.dataset.title);
rm.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
rm.addEventListener('click', function () { toggle(p, false); });
li.appendChild(thumb); li.appendChild(nm); li.appendChild(pr); li.appendChild(rm);
lines.appendChild(li);
});
empty.hidden = s.length > 0;
var unlocked = s.length >= threshold;
var discount = unlocked ? Math.round(subtotal * percent / 100) : 0;
sub.textContent = money(subtotal);
save.textContent = '−' + money(discount);
saveRow.hidden = !unlocked;
total.textContent = money(subtotal - discount);
bar.style.width = Math.min(100, (s.length / threshold) * 100) + '%';
var left = threshold - s.length;
msg.textContent = unlocked ? 'Nice! ' + percent + '% off is applied at checkout.' :
(s.length === 0 ? 'Pick ' + threshold + ' or more pet items to save ' + percent + '%.' :
'Add ' + left + ' more to unlock ' + percent + '% off.');
if (unlocked && !wasUnlocked) { unlock.classList.remove('is-on'); void unlock.offsetWidth; unlock.classList.add('is-on'); }
if (!unlocked) unlock.classList.remove('is-on');
wasUnlocked = unlocked;
[total, mTotal].forEach(function (t) { if (!t) return; t.classList.remove('hp-bump'); void t.offsetWidth; t.classList.add('hp-bump'); });

var tag = s.filter(function (p) { return p.dataset.personalize === 'true'; })[0];
var label = s.length === 0 ? el.dataset.ctaEmpty :
(tag ? (s.length > 1 ? el.dataset.ctaTag : el.dataset.ctaTagOnly) : el.dataset.ctaAdd);
cta.forEach(function (b) {
b.disabled = s.length === 0;
b.querySelector('span').textContent = (b.dataset.hpCta === 'short' && s.length) ? el.dataset.ctaShort : label;
});
if (mBar) {
mBar.classList.toggle('is-on', s.length > 0);
mCount.textContent = s.length + (s.length === 1 ? ' item' : ' items') + (unlocked ? ' · ' + percent + '% off' : ' · +' + left + ' to save ' + percent + '%');
mTotal.textContent = money(subtotal - discount);
}
err.hidden = true;
}

function toggle(p, force) {
var on = typeof force === 'boolean' ? force : !p.classList.contains('is-selected');
if (on && p.dataset.kind === 'tag') {
picks.forEach(function (o) { if (o !== p && o.dataset.kind === 'tag') setSel(o, false); });
}
setSel(p, on); render();
}
function setSel(p, on) {
p.classList.toggle('is-selected', on);
var b = p.querySelector('.hp-pick__toggle'); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
}

picks.forEach(function (p) {
p.querySelector('.hp-pick__toggle').addEventListener('click', function () { toggle(p); });
var sel = p.querySelector('select');
if (sel) sel.addEventListener('change', function () {
var o = sel.options[sel.selectedIndex];
var pr = p.querySelector('[data-hp-price]'); if (pr) pr.textContent = money(+o.dataset.price);
if (!p.classList.contains('is-selected')) setSel(p, true);
render();
});
});

function go() {
var s = selected(); if (!s.length) return;
var tag = s.filter(function (p) { return p.dataset.personalize === 'true'; })[0];
var items = s.filter(function (p) { return p.dataset.personalize !== 'true'; })
.map(function (p) { return { id: +variantOf(p).id, quantity: 1 }; });
cta.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'Adding…'; });
var next = function () { window.location.href = tag ? tag.dataset.url + (tag.dataset.url.indexOf('?') > -1 ? '&' : '?') + 'bundle=1' : root + 'cart'; };
if (!items.length) { next(); return; }
fetch(root + 'cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: items })
}).then(function (r) { if (!r.ok) throw r; return r.json(); })
.then(next)
.catch(function () { err.hidden = false; render(); });
}
cta.forEach(function (b) { b.addEventListener('click', go); });

// Hide sticky bar while the summary card itself is on screen
var summary = el.querySelector('.hp-summary');
if (mBar && summary && 'IntersectionObserver' in window) {
new IntersectionObserver(function (en) { mBar.style.visibility = en[0].isIntersecting ? 'hidden' : 'visible'; }, { threshold: 0.3 }).observe(summary);
new IntersectionObserver(function (en) { if (!en[0].isIntersecting) mBar.classList.remove('is-on'); else render(); }, { threshold: 0 }).observe(el);
}
render();
}

function initAll(root) {
initReveal(root);
(root || document).querySelectorAll('[data-hp-bundle]').forEach(initBundle);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
else initAll();
// Theme editor support
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
